import ReactDOM from "react-dom/client";
import { AppLayout } from "./AppLayout";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<AppLayout>{<App />}</AppLayout>);
